import React, { Component } from 'react';

export default class ScaleQuestionItem extends Component {

	state = {
		tapped:false, 
		hover:false,
		currentSelected: -1,
	}
	
	buttonClicked = (inx)=>{
		this.setState({currentSelected: inx});
		this.props.onClick(this.props.itemIndex, this.props.itemKey, inx);
	}

	render() {
		const {padding, scaleSize, itemKey, condition, values, customizeValues} = this.props

		const radioButtons = [];
		for(let i=0; i<scaleSize; i++){radioButtons.push(i)}

		return <div id={itemKey}>
			<div id="condition_cont" style={{
					color: "black",
					fontSize:18,
					fontFamily:"simplerReg",
					marginLeft: padding,
				}}>
				<span>{condition}</span>
			</div>
			
			<div id="button_container" style={{
				position: "relative",
				top: 10,
				marginBottom: padding,
				marginLeft: padding,
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
			}}> 
				<div style={{position:"absolute", height:1, backgroundColor:global.colorTheme.main, width: "100%",}}/>

				{radioButtons.map((button, i) => 
					<RadioButton key={i} index ={i} customizeValues={customizeValues}
					isChoosen={this.state.currentSelected === i} value={values ? values[i] : null}
					onClick={this.buttonClicked}
					/>
				)}			
			</div>
			
			
	  	</div>
	}
}

class RadioButton extends Component {
    
    state = {tapped:false, hover:false}

	handleClick = () => {
		this.props.onClick(this.props.index);
	}

	render() {
		const {index, value, isChoosen, customizeValues} = this.props
        
        const buttonSize = 30;
		
		return <div onClick={this.handleClick} 

		onMouseEnter={() => {
			this.setState({hover:true})
		}} onMouseLeave={() => {
			this.setState({hover:false, tapped:false})
		}} onMouseDown={()=>{
			this.setState({tapped:true, hover:false})
		}} onMouseUp={()=>{
			this.setState({tapped:false, hover:false})
		}}
		
		onTouchStart={()=>{this.setState({hover:true})}}
		onTouchEnd={()=>{this.setState({hover:false})}}	
		onTouchCancel={()=>{this.setState({hover:false})}}	
        
        style={{
			// position:"absolute",
            height: buttonSize,
            minWidth: buttonSize,
			cursor:"pointer",
			zIndex: 10,
			
			display: "inline-block",
			textAlign: "center",
			lineHeight: 2,
			padding: value && value.length >= 3 ? "0 6px 0 6px" : "",

			WebkitTapHighlightColor: "transparent",
            borderRadius: buttonSize / 2,
            backgroundColor: isChoosen || this.state.tapped ? "black" : this.state.hover ? global.colorTheme.secondaryLight : "white",
			border: isChoosen || this.state.tapped ? "1px solid black" : this.state.hover ? "1px solid black" : "1px solid " + global.colorTheme.main,
			color: isChoosen || this.state.tapped ? "white" : global.colorTheme.main,

            transition:"all 0.25s ease-out"
		}}> {customizeValues ? value : index+1} </div>

	}
}


// WEBPACK FOOTER //
// ./src/Comp/Shared/ScaleQuestionItem.js